import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSimCard,
  faSpinner,
  faTriangleExclamation,
  faChevronDown,
  faMobileScreen,
} from '@fortawesome/free-solid-svg-icons';
import StoreHeader from '../../components/StoreHeader';
import Footer from '../../components/Footer';
import { getSupportedDevices } from './guideApi';
import './esimguide.css';

const STEP_KEYS = ['order.step1', 'order.step2', 'order.step3', 'order.step4'];
const FAQ_KEYS = [
  { q: 'contact.faq.esim.title', a: 'contact.faq.esim.content' },
  { q: 'contact.faq.phones.title', a: 'contact.faq.phones.content' },
  { q: 'contact.faq.validity.title', a: 'contact.faq.validity.content' },
  { q: 'contact.faq.payment.title', a: 'contact.faq.payment.content' },
];

const EsimGuide = () => {
  const { t } = useTranslation();
  const [devices, setDevices] = useState({ loading: true });

  useEffect(() => {
    let cancelled = false;
    getSupportedDevices()
      .then((data) => !cancelled && setDevices({ data }))
      .catch((err) => !cancelled && setDevices({ error: err.message }));
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="guide">
      <StoreHeader />

      <section className="guide-hero">
        <p className="guide-eyebrow">
          <FontAwesomeIcon icon={faSimCard} />
          {t('guide.eyebrow')}
        </p>
        <h1 className="guide-title">{t('guide.title')}</h1>
      </section>

      <main className="guide-main">
        {/* eSIM nedir */}
        <section className="guide-section">
          <h2 className="guide-section-title">{t('guide.intro.title')}</h2>
          <p className="guide-body">{t('guide.intro.body')}</p>
        </section>

        {/* Nasıl etkinleştirilir */}
        <section className="guide-section">
          <h2 className="guide-section-title">{t('guide.steps.title')}</h2>
          <ol className="guide-steps">
            {STEP_KEYS.map((key, i) => (
              <li key={key}>
                <span className="guide-step-num">{i + 1}</span>
                <span className="guide-step-text">{t(key)}</span>
              </li>
            ))}
          </ol>
        </section>

        {/* Desteklenen cihazlar */}
        <section className="guide-section">
          <h2 className="guide-section-title">
            <FontAwesomeIcon icon={faMobileScreen} /> {t('guide.devices.title')}
          </h2>
          <p className="guide-body">{t('guide.devices.desc')}</p>

          {devices.loading && (
            <div className="guide-state"><FontAwesomeIcon icon={faSpinner} spin size="2x" /></div>
          )}
          {devices.error && (
            <div className="guide-state">
              <FontAwesomeIcon icon={faTriangleExclamation} size="2x" />
              <p>{t('home.error.title')}</p>
            </div>
          )}
          {devices.data?.map((group) => (
            <div key={group.type} className="guide-device-group">
              {devices.data.length > 1 && (
                <h3 className="guide-device-type">{group.type}</h3>
              )}
              <div className="guide-brands">
                {(group.brands || []).map((brand) => (
                  <details key={brand.title} className="guide-brand">
                    <summary>
                      <span>{brand.title}</span>
                      <span className="guide-brand-count">{brand.models?.length || 0}</span>
                      <FontAwesomeIcon icon={faChevronDown} className="guide-brand-chevron" />
                    </summary>
                    <ul className="guide-models">
                      {(brand.models || []).map((m) => (
                        <li key={m}>{m}</li>
                      ))}
                    </ul>
                  </details>
                ))}
              </div>
            </div>
          ))}
        </section>

        {/* SSS */}
        <section className="guide-section">
          <h2 className="guide-section-title">{t('guide.faq.title')}</h2>
          <div className="guide-faq">
            {FAQ_KEYS.map(({ q, a }) => (
              <details key={q} className="guide-faq-item">
                <summary>
                  <span>{t(q)}</span>
                  <FontAwesomeIcon icon={faChevronDown} className="guide-brand-chevron" />
                </summary>
                <p>{t(a)}</p>
              </details>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default EsimGuide;
